var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageWarning48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Message/Warning48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconWarning48",
    transform: "translate(-295.000000, -132.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "04-Honeycomb-Foundation/icon/Message/Warning48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconWarning",
    transform: "translate(3.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8664512,-0.463148291 L42.5737965,35.5010229 C42.8493739,35.9796412 42.6847768,36.5910377 42.2061585,36.8666152 C42.0543827,36.9540042 41.8823176,37 41.7071813,37 L0.292490876,37 C-0.259793874,37 -0.707509124,36.5522847 -0.707509124,36 C-0.707509124,35.8248637 -0.661513279,35.6527986 -0.574124275,35.5010229 L20.1332209,-0.463148291 C20.4087984,-0.941766623 21.0201949,-1.10636377 21.4988132,-0.830786306 C21.65163,-0.742797925 21.7784629,-0.615965042 21.8664512,-0.463148291 Z",
    id: "Triangle",
    fill: "#F95200"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Stroke",
    fill: "#FFFFFF",
    x: 19,
    y: 13,
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Dot",
    fill: "#FFFFFF",
    x: 19,
    y: 29,
    width: 4,
    height: 3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWarning48);
export default __webpack_public_path__ + "static/media/messageWarning48.2907625ab462d39e49abeb5a2b3295db.svg";
export { ForwardRef as ReactComponent };